import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import MainHeading from '../components/MainHeading';
import ProductSection from '../components/ProductSection';
import CompanyLogos from '../components/CompanyLogos';
import Testimonials from "../components/Testimonials";

import { Container, Box, useTheme, useMediaQuery } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const Home = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleFormSubmit = (productTitle, role, company) => {
      navigate(`/coaches?product=${productTitle}&role=${role}&company=${company}`, {
        state: { productTitle, role, company }
    });
    };

    return (
        <>
          <Container 
            maxWidth="lg" 
            // disableGutters
            sx={{ 
              minHeight: '120vh',
              py: 0, 
              display: 'flex', 
              flexDirection: 'column', 
              justifyContent: 'center', 
              position: 'relative', // Ensures absolute positioning works properly
              pb: 25,
              marginTop: '-16px', 
            }}
          >
            {/* Banner */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: `50%`,
                transform: 'translateX(-50%)',     // Centers it properly
                width: { xs: '100%', sm: '100%', md: 'calc(100% - 78px)' },
                maxWidth: '1200px',  
                backgroundColor: '#04003F',
                color: '#FFFFFF',
                // textTransform: 'capitalize',
                textAlign: 'center',
                px: 2,
                py: 1,
                fontFamily: 'Roboto',
                fontWeight: 400, // Regular
                fontSize: { xs: '0.9rem', sm: '0.95rem', md: '1rem' }, // Responsive font size
                lineHeight: { xs: 1, sm: 1, md: 1.2 },
                // wordWrap: 'break-word',
                // whiteSpace: 'normal',
                zIndex: 10,
              }}
            >
              <StarIcon 
                sx={{ 
                  color: '#FFD23E', 
                  fontSize: '1rem', 
                  verticalAlign: 'middle', 
                  position: 'relative', 
                  top: '-2px',
                  mr: 0.5, 
                }} 
              />
              {/* Show this only on desktop */}
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                180+ sessions completed - 99% 5-star ratings.
              </Box>
              {/* Show this only on mobile */}
              <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                180+ sessions completed - 99% 5-star ratings.
              </Box>
            </Box>

            {/* Main Heading (55% Width) - Stays in Place */}
            <MainHeading />

            {isSmallScreen ? (
              <>
                {/* 2️⃣ Logos come next on mobile */}
                <Box sx={{ mt: 2 }}>
                  <CompanyLogos />
                </Box>

                {/* 3️⃣ Product section below logos */}
                <Box sx={{ 
                       mt: 2,
                       mr: 3.5,
                       zIndex: 10, 
                    }}>
                  <ProductSection title="Ace with Mocks" onFormSubmit={handleFormSubmit} />
                </Box>
              </>
            ) : (
              <>
                {/* 2️⃣ Product section positioned beside heading on large screens */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: '130px',
                    left: '55%',
                    width: '43%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                  }}
                >
                  <ProductSection title="Ace with Mocks" onFormSubmit={handleFormSubmit} />
                </Box>

                {/* 3️⃣ Logos below everything on large screens */}
                <Box sx={{ mt: { xs: 9, sm: 9, md: 4 } }}>
                  <CompanyLogos />
                </Box>
              </>
            )}

            {/* Testimonials Section */}
            <Box sx={{ mt: { xs: 0, sm: 0, md: -32 }, mb: { xs: -25, sm: -25, md: 0 } }}>
              <Testimonials />
            </Box>
            

          </Container>
        </>
    );
};

export default Home;
